<!-- Aviso: Meetzy ha mejorado el agente y espera decisión.
     Lo visible responde a cinco preguntas y nada más: qué agente, cuánto
     mejora, qué ha tocado, en qué estado está y qué hago yo ahora. El resto
     (rondas, notas del equipo, evaluaciones) vive en el desplegable. -->
<div *ngIf="show && current" class="mz-modal fixed inset-0 z-[10000] overflow-y-auto">
  <div class="fixed inset-0 bg-black/50 backdrop-blur-md"></div>

  <div class="flex min-h-full items-center justify-center p-4">
    <div class="mz-card relative w-full max-w-[560px] overflow-hidden rounded-[28px]"
         [ngClass]="isDarkMode ? 'bg-[#15181a] ring-1 ring-white/[.07]' : 'bg-white'">

      <!-- Atmósfera de marca detrás del héroe, MUY tenue. -->
      <div class="mz-aurora" [ngClass]="{ 'mz-aurora--dark': isDarkMode }"></div>

      <div class="relative max-h-[86vh] overflow-y-auto">

        <!-- Héroe -->
        <div class="px-10 pt-11 text-center">
          <app-meetzy-orb [size]="104" [dark]="isDarkMode" [mood]="deployed ? 'happy' : 'idle'"></app-meetzy-orb>

          <h2 class="mz-headline mt-7" [ngClass]="isDarkMode ? 'text-[#f2f5f3]' : 'text-[#10251c]'">
            {{ deployed ? 'Your agent is live' : (stale ? 'This version no longer applies' : 'Meetzy improved your agent') }}
          </h2>
          <!-- Lo primero que hay que entender: existe una version nueva, es un
               BORRADOR, y la decision es suya. -->
          <p *ngIf="!deployed && !stale" class="mx-auto mt-2 max-w-[400px] text-[14px] leading-snug"
             [ngClass]="isDarkMode ? 'text-[#8b968f]' : 'text-[#6b7772]'">
            There is a new draft version waiting for you to decide whether to put it live.
          </p>
          <p *ngIf="!deployed && stale" class="mx-auto mt-2 max-w-[420px] text-[14px] leading-snug"
             [ngClass]="isDarkMode ? 'text-[#8b968f]' : 'text-[#6b7772]'">
            Someone changed the agent after this version was prepared, so it can no longer go live as is.
            Meetzy will work again on the new version with what you review.
          </p>

          <!-- Qué agente, sin ambigüedad. -->
          <div class="mt-3.5 inline-flex max-w-full items-center gap-2 rounded-full px-3.5 py-1.5"
               [ngClass]="isDarkMode ? 'bg-white/[.06]' : 'bg-[#f0f3f1]'">
            <span class="h-[7px] w-[7px] shrink-0 rounded-full bg-gradient-to-br from-[#a8e85f] to-[#0ec79a]"></span>
            <span class="truncate text-[13.5px] font-medium"
                  [ngClass]="isDarkMode ? 'text-[#e7ece9]' : 'text-[#1d2e28]'">{{ current.assistant_name }}</span>
          </div>
        </div>

        <!-- El salto -->
        <div class="mz-rise px-10 pt-9 text-center">
          <div class="flex items-end justify-center gap-6">
            <div *ngIf="gained(current) > 0">
              <div class="mz-eyebrow" [ngClass]="isDarkMode ? 'text-[#7f8c85]' : 'text-[#6b7772]'">Before</div>
              <div class="mz-display mt-1.5" [ngClass]="isDarkMode ? 'text-[#68766f]' : 'text-[#87958f]'">
                {{ baseline(current) }}
              </div>
            </div>

            <svg *ngIf="gained(current) > 0" class="mz-bigarrow" viewBox="0 0 64 34" aria-hidden="true">
              <defs>
                <linearGradient [attr.id]="'mzArrow' + uid" x1="0%" y1="0%" x2="100%" y2="0%">
                  <stop offset="0%" [attr.stop-color]="isDarkMode ? '#9fe05c' : '#5cae2e'" />
                  <stop offset="100%" [attr.stop-color]="isDarkMode ? '#16c7a0' : '#028a6b'" />
                </linearGradient>
              </defs>
              <path d="M2 17h44M40 6l13 11-13 11" fill="none" [attr.stroke]="'url(#mzArrow' + uid + ')'"
                    stroke-width="5" stroke-linecap="round" stroke-linejoin="round" />
            </svg>

            <div>
              <div class="mz-eyebrow" [ngClass]="isDarkMode ? 'text-[#5fd3a6]' : 'text-[#0a8060]'">
                {{ gained(current) > 0 ? 'Now' : 'Checks passed' }}
              </div>
              <div class="mz-display mz-grad mt-1.5" [ngClass]="{ 'mz-grad--dark': isDarkMode }">
                {{ current.tests?.passed }}<span *ngIf="gained(current) === 0"
                  class="mz-display-unit">/{{ current.tests?.total }}</span>
              </div>
            </div>
          </div>

          <p *ngIf="gained(current) > 0" class="mt-2 text-[12.5px]"
             [ngClass]="isDarkMode ? 'text-[#7f8c85]' : 'text-[#6b7772]'">
            out of {{ current.tests?.total }} checks
          </p>

          <p class="mx-auto mt-6 max-w-[430px] text-[17px] font-medium leading-snug"
             [ngClass]="isDarkMode ? 'text-[#f2f5f3]' : 'text-[#10251c]'">
            {{ headlineImpact() }}
          </p>
          <p class="mx-auto mt-2 max-w-[430px] text-[13px] leading-relaxed"
             [ngClass]="isDarkMode ? 'text-[#8b968f]' : 'text-[#6b7772]'">
            {{ proofLine(current) }}
          </p>
        </div>

        <!-- Si hay más de una mejora, el resto va aquí. -->
        <div *ngIf="otherImpacts().length" class="mx-10 mt-7 rounded-2xl px-5 py-4"
             [ngClass]="isDarkMode ? 'bg-white/[.04]' : 'bg-[#f5f7f6]'">
          <div class="mz-eyebrow" [ngClass]="isDarkMode ? 'text-[#7f8c85]' : 'text-[#6b7772]'">And also</div>
          <ul class="mt-2.5 space-y-2">
            <li *ngFor="let item of otherImpacts()" class="flex gap-2.5 text-[13.5px] leading-relaxed"
                [ngClass]="isDarkMode ? 'text-[#cdd6d1]' : 'text-[#33423c]'">
              <span class="mt-[7px] h-[5px] w-[5px] shrink-0 rounded-full"
                    [ngClass]="isDarkMode ? 'bg-[#5fd3a6]' : 'bg-[#0a8060]'"></span>
              <span>{{ item }}</span>
            </li>
          </ul>
        </div>

        <!-- Estado -->
        <div class="mt-6 flex flex-wrap items-center justify-center gap-2 px-10">
          <span *ngIf="!deployed" class="inline-flex items-center gap-1.5 rounded-full px-3 py-1 text-[12px] font-medium"
                [ngClass]="isDarkMode ? 'bg-amber-400/[.12] text-amber-200/90' : 'bg-amber-50 text-amber-800'">
            <span class="h-[6px] w-[6px] rounded-full bg-current opacity-70"></span>
            {{ stale ? 'Outdated — the agent changed' : 'Draft — not in production' }}
          </span>
          <span class="rounded-full px-3 py-1 text-[12px] font-medium"
                [ngClass]="isDarkMode ? 'bg-white/[.06] text-[#b9c3bd]' : 'bg-[#f0f3f1] text-[#5b6a64]'">
            Version {{ current.version_number }}, from {{ current.base_version_number }}
          </span>
          <span *ngIf="riskLabel() && !deployed" [title]="riskHint()"
                class="rounded-full px-3 py-1 text-[12px] font-medium"
                [ngClass]="riskIsWarning()
                  ? (isDarkMode ? 'bg-amber-400/[.12] text-amber-200/90' : 'bg-amber-50 text-amber-800')
                  : (isDarkMode ? 'bg-white/[.06] text-[#b9c3bd]' : 'bg-[#f0f3f1] text-[#5b6a64]')">
            {{ riskLabel() }}
          </span>
          <span *ngIf="newChecks().length" class="rounded-full px-3 py-1 text-[12px] font-medium"
                [ngClass]="isDarkMode ? 'bg-white/[.06] text-[#b9c3bd]' : 'bg-[#f0f3f1] text-[#5b6a64]'">
            {{ newChecks().length }} new check{{ newChecks().length === 1 ? '' : 's' }} from your notes
          </span>
        </div>

        <!-- Riesgo de negocio o externo: dónde mirar, con la muestra. -->
        <div *ngIf="riskIsWarning() && !deployed && !stale" class="mx-10 mt-5 rounded-2xl px-4 py-3 text-[12.5px] leading-relaxed"
             [ngClass]="isDarkMode ? 'bg-amber-400/[.08] text-amber-100/90' : 'bg-amber-50 text-amber-900'">
          <p class="font-medium">{{ riskHint() }}</p>
          <p *ngIf="riskReasons().length" class="mt-1 opacity-80">{{ riskReasons().join(' · ') }}</p>
        </div>

        <!-- El detalle, plegado. Quien confía despliega sin abrirlo. -->
        <div class="mt-6 px-10">
          <button (click)="showEvidence = !showEvidence"
                  class="mx-auto flex items-center gap-1.5 text-[13px] font-medium mz-quiet"
                  [ngClass]="{ 'mz-quiet--dark': isDarkMode }">
            {{ showEvidence ? 'Hide the detail' : 'See the detail' }}
            <svg class="h-3.5 w-3.5 transition-transform" [class.rotate-180]="showEvidence"
                 viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2"
                 stroke-linecap="round" stroke-linejoin="round"><path d="m6 9 6 6 6-6" /></svg>
          </button>
        </div>

        <div *ngIf="showEvidence" class="mz-rise mx-10 mt-5 space-y-5 border-t pt-5"
             [ngClass]="isDarkMode ? 'border-white/[.08]' : 'border-[#eceeed]'">

          <div *ngIf="improvements().length">
            <div class="mz-eyebrow" [ngClass]="isDarkMode ? 'text-[#7f8c85]' : 'text-[#6b7772]'">What changed in the prompt</div>
            <ul class="mt-2.5 space-y-2">
              <li *ngFor="let item of improvements()" class="text-[13px] leading-relaxed"
                  [ngClass]="isDarkMode ? 'text-[#b9c3bd]' : 'text-[#5b6a64]'">{{ item }}</li>
            </ul>
          </div>

          <div *ngIf="rounds().length">
            <div class="mz-eyebrow" [ngClass]="isDarkMode ? 'text-[#7f8c85]' : 'text-[#6b7772]'">Round by round</div>
            <ul class="mt-2.5 space-y-1.5">
              <li *ngFor="let r of rounds()" class="flex items-baseline gap-3 text-[12.5px]"
                  [ngClass]="isDarkMode ? 'text-[#b9c3bd]' : 'text-[#5b6a64]'">
                <span class="w-12 shrink-0 tabular-nums"
                      [ngClass]="isDarkMode ? 'text-[#7f8c85]' : 'text-[#6b7772]'">Round {{ r.round }}</span>
                <span class="flex-1 leading-relaxed">{{ roundLabel(r) }}</span>
              </li>
            </ul>
          </div>

          <div *ngIf="newChecks().length">
            <div class="mz-eyebrow" [ngClass]="isDarkMode ? 'text-[#7f8c85]' : 'text-[#6b7772]'">New checks, written from your notes</div>
            <ul class="mt-2.5 space-y-1.5">
              <li *ngFor="let c of newChecks()" class="text-[12.5px] leading-relaxed"
                  [ngClass]="isDarkMode ? 'text-[#b9c3bd]' : 'text-[#5b6a64]'">{{ c }}</li>
            </ul>
          </div>

          <div *ngIf="sectionsTouched().length">
            <div class="mz-eyebrow" [ngClass]="isDarkMode ? 'text-[#7f8c85]' : 'text-[#6b7772]'">Prompt sections touched</div>
            <div class="mt-2.5 flex flex-wrap gap-1.5">
              <span *ngFor="let s of sectionsTouched()"
                    class="rounded-md px-2 py-1 font-mono text-[11.5px]"
                    [ngClass]="isDarkMode ? 'bg-white/[.06] text-[#b9c3bd]' : 'bg-[#f0f3f1] text-[#5b6a64]'">{{ s }}</span>
            </div>
          </div>

          <!-- El cambio exacto del prompt, línea a línea (G2: se aprueba sobre el diff, no sobre la narración) -->
          <div *ngIf="diff()">
            <button (click)="showDiff = !showDiff" class="mz-eyebrow mz-quiet" [ngClass]="{ 'mz-quiet--dark': isDarkMode }">
              {{ showDiff ? 'Hide the exact change' : 'See the exact change, line by line' }}
            </button>
            <div *ngIf="showDiff" class="mt-2.5">
              <p class="mb-2 text-[11.5px]" [ngClass]="isDarkMode ? 'text-[#7f8c85]' : 'text-[#6b7772]'">
                <span class="text-emerald-500">+{{ diff()!.added }}</span> added ·
                <span class="text-red-500">−{{ diff()!.removed }}</span> removed
              </p>
              <div class="max-h-[320px] overflow-auto rounded-xl border font-mono text-[11.5px] leading-relaxed"
                   [ngClass]="isDarkMode ? 'border-white/[.08] bg-white/[.03]' : 'border-[#eceeed] bg-[#f7f9f8]'">
                <ng-container *ngFor="let c of diff()!.chunks">
                  <div *ngIf="c.type === 'skip'" class="px-3 py-1 text-center text-[10.5px]"
                       [ngClass]="isDarkMode ? 'text-[#7f8c85]' : 'text-[#9aa5a0]'">··· {{ c.count }} unchanged line{{ c.count === 1 ? '' : 's' }} ···</div>
                  <div *ngIf="c.type !== 'skip'" class="whitespace-pre-wrap break-words px-3 py-0.5"
                       [ngClass]="c.type === 'add'
                         ? (isDarkMode ? 'bg-emerald-500/[.14] text-[#e7ece9]' : 'bg-emerald-50 text-[#10251c]')
                         : c.type === 'del'
                           ? (isDarkMode ? 'bg-red-500/[.14] text-[#e7ece9] line-through' : 'bg-red-50 text-[#10251c] line-through')
                           : (isDarkMode ? 'text-[#b9c3bd]' : 'text-[#5b6a64]')">
                    <span class="mr-2 inline-block w-3 select-none opacity-60">{{ c.type === 'add' ? '+' : c.type === 'del' ? '−' : ' ' }}</span>{{ c.text || ' ' }}
                  </div>
                </ng-container>
              </div>
            </div>
          </div>

          <div *ngIf="evidenceNotes().length">
            <div class="mz-eyebrow" [ngClass]="isDarkMode ? 'text-[#7f8c85]' : 'text-[#6b7772]'">What your team wrote</div>
            <ul class="mt-2.5 space-y-2">
              <li *ngFor="let n of evidenceNotes()"
                  class="border-l-2 pl-3 text-[13px] leading-relaxed"
                  [ngClass]="isDarkMode ? 'border-white/[.12] text-[#b9c3bd]' : 'border-[#e2e6e4] text-[#5b6a64]'">
                {{ n }}
              </li>
            </ul>
          </div>

          <div *ngIf="detail?.evidence?.eval_failures?.length">
            <div class="mz-eyebrow" [ngClass]="isDarkMode ? 'text-[#7f8c85]' : 'text-[#6b7772]'">Failing evaluations</div>
            <div class="mt-2.5 flex flex-wrap gap-1.5">
              <span *ngFor="let e of detail.evidence.eval_failures.slice(0, 6)"
                    class="rounded-full px-2.5 py-1 text-[11.5px]"
                    [ngClass]="isDarkMode ? 'bg-white/[.06] text-[#b9c3bd]' : 'bg-[#f0f3f1] text-[#5b6a64]'">
                {{ e.name }} · {{ e.count }}
              </span>
            </div>
          </div>
        </div>

        <div *ngIf="error" class="mx-10 mt-6 rounded-2xl px-4 py-3 text-[12.5px]"
             [ngClass]="isDarkMode ? 'bg-red-400/[.08] text-red-200/90' : 'bg-red-50 text-red-700'">
          {{ error }}
        </div>

        <!-- Acciones: una principal, el resto en voz baja -->
        <div class="px-10 pt-7 pb-9">
          <!-- Desplegada -->
          <button *ngIf="deployed" (click)="dismiss()"
                  class="mz-cta w-full rounded-2xl py-3.5 text-[15px] font-semibold text-white">
            Done
          </button>

          <!-- Obsoleta: no hay nada que desplegar -->
          <button *ngIf="!deployed && stale" (click)="dismiss()"
                  class="w-full rounded-2xl py-3.5 text-[15px] font-semibold"
                  [ngClass]="isDarkMode ? 'bg-white text-[#10251c]' : 'bg-[#10251c] text-white'">
            Got it
          </button>

          <!-- Descartar: primero el motivo -->
          <div *ngIf="!deployed && !stale && askingReason" class="rounded-2xl border p-4"
               [ngClass]="isDarkMode ? 'border-white/[.1] bg-white/[.03]' : 'border-[#e2e6e4] bg-[#f7f9f8]'">
            <label for="mz-discard-reason" class="block text-[13px] font-medium"
                   [ngClass]="isDarkMode ? 'text-[#f2f5f3]' : 'text-[#10251c]'">Why are you discarding it?</label>
            <p class="mt-0.5 text-[12px] leading-relaxed" [ngClass]="isDarkMode ? 'text-[#8b968f]' : 'text-[#6b7772]'">
              Optional, but it helps: Meetzy reads it before the next proposal so it doesn't repeat the same approach.
            </p>
            <textarea id="mz-discard-reason" [(ngModel)]="discardReason" rows="2" maxlength="600"
                      placeholder="E.g. the new closing doesn't match our tone"
                      class="mt-2.5 w-full resize-none rounded-lg border px-3 py-2 text-[13px] outline-none focus:ring-2 focus:ring-emerald-500"
                      [ngClass]="isDarkMode ? 'border-white/[.12] bg-[#15181a] text-[#f2f5f3]' : 'border-[#dfe4e2] bg-white text-[#10251c]'"></textarea>
            <div class="mt-3 flex items-center justify-end gap-3 text-[13px]">
              <button (click)="cancelDiscard()" class="mz-quiet" [ngClass]="{ 'mz-quiet--dark': isDarkMode }">Back</button>
              <button (click)="discard()" [disabled]="discarding"
                      class="rounded-lg px-3.5 py-2 font-medium disabled:opacity-50"
                      [ngClass]="isDarkMode ? 'bg-white text-[#10251c]' : 'bg-[#10251c] text-white'">
                {{ discarding ? 'Discarding…' : 'Discard the version' }}
              </button>
            </div>
          </div>

          <!-- Camino normal -->
          <ng-container *ngIf="!deployed && !stale && !askingReason">
            <button (click)="deploy()" [disabled]="deploying"
                    class="mz-cta w-full rounded-2xl py-3.5 text-[15px] font-semibold text-white disabled:opacity-60">
              {{ deploying ? 'Deploying…' : 'Deploy to production' }}
            </button>

            <p class="mx-auto mt-3 max-w-[400px] text-center text-[12px] leading-relaxed"
               [ngClass]="isDarkMode ? 'text-[#7f8c85]' : 'text-[#6b7772]'">
              It is a draft: it is waiting for you, not answering calls. Review it whenever you
              want — your agent keeps working exactly as it does today until you put this live.
            </p>

            <div class="mt-6 flex items-center justify-center gap-5 text-[13px]">
              <button (click)="dismiss()" class="mz-quiet" [ngClass]="{ 'mz-quiet--dark': isDarkMode }">Not now</button>
              <span [ngClass]="isDarkMode ? 'text-[#3b4440]' : 'text-[#dfe4e2]'">·</span>
              <button (click)="openInEditor()" class="mz-quiet" [ngClass]="{ 'mz-quiet--dark': isDarkMode }">Open in editor</button>
              <span [ngClass]="isDarkMode ? 'text-[#3b4440]' : 'text-[#dfe4e2]'">·</span>
              <button (click)="beginDiscard()" class="mz-quiet" [ngClass]="{ 'mz-quiet--dark': isDarkMode }">Discard</button>
            </div>
          </ng-container>

          <p *ngIf="remaining > 0 && !deployed" class="mt-5 text-center text-[12px]"
             [ngClass]="isDarkMode ? 'text-[#7f8c85]' : 'text-[#6b7772]'">
            {{ remaining }} more waiting
          </p>
        </div>
      </div>
    </div>
  </div>
</div>
